import { render, staticRenderFns } from "./servicePersonal.vue?vue&type=template&id=26c129bf&"
import script from "./servicePersonal.vue?vue&type=script&lang=js&"
export * from "./servicePersonal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports